var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9a3d3612bd64dac25c058ab201ccaa68be742b25"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website-api@garage-project"]={id:"9a3d3612bd64dac25c058ab201ccaa68be742b25"};
      